<script lang="ts">
  import { Header } from "@/widgets/header";
  import type { LayoutData } from "./$types";
  import type { Snippet } from "svelte";
  import "@/app.css";
  import { page, updated } from "$app/state";
  import { onMount } from "svelte";
  import { invalidate } from "$app/navigation";
  import { supabase } from "@/shared/api/supabaseClient";
  import { setSessionContext } from "@/shared/lib/layoutContext";
  import BugReportLink from "@/shared/ui/BugReportLink.svelte";
  import Button from "@/shared/ui/Button.svelte";

  let { data, children }: { data: LayoutData; children: Snippet } = $props();

  setSessionContext(() => data);

  onMount(() => {
    const {
      data: { subscription }
    } = supabase.auth.onAuthStateChange(() => {
      invalidate("supabase:auth");
    });

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch((err) => {
        console.error("Service Worker registration failed:", err);
      });
    }

    return () => subscription.unsubscribe();
  });

  let isGamePage = $derived(
    page.url.pathname.startsWith("/table/") || page.url.pathname === "/tutorial"
  );
  let isFullBleedPage = $derived(isGamePage || page.url.pathname.startsWith("/rules/"));
</script>

<div class="flex flex-col min-h-screen">
  <Header full={isFullBleedPage} />

  <main
    class={["flex-1 flex flex-col w-full max-w-full mx-auto box-border", isFullBleedPage || "p-4"]}
  >
    <div class={[isFullBleedPage && "h-[calc(100vh-104px)] max-h-[calc(100vh-108px)]"]}>
      {@render children()}
    </div>
  </main>

  <footer class="mt-auto flex flex-col justify-center items-center p-3 sm:px-0 sm:py-3 relative">
    <p>
      <BugReportLink />
    </p>
    {#if updated.current}
      <div class="absolute bottom-3 left-3">
        <p>
          A new version of the app is available

          <Button size="sm" onclick={() => location.reload()}>reload the page</Button>
        </p>
      </div>
    {/if}
  </footer>
</div>
